import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// REDIRECT TO EDUCATION FROM BEYOND FOR OLD LINKS
if (window.location.href.indexOf('beyond.genesys.com') >= 0)
  window.location.href = window.location.href.replace(
    'beyond.genesys.com',
    'education.genesys.com'
  );

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
